import { createDefaultMutationHook } from "hooks/useMutationHandler";
import { UPDATE_STACK_DEPENDENCY } from "views/Stack/Dependencies/gql";

const useUpdateStackDependency = createDefaultMutationHook(UPDATE_STACK_DEPENDENCY);

export default useUpdateStackDependency;